<template>
    <v-container fluid class="pa-0 pb-8">
        <v-container class="container-custom">
            <Breadcrumbs :title="$t('modules.portalalumno.dashboard.breadcrumbs.title')" :description="$t('modules.portalalumno.dashboard.breadcrumbs.description')"></Breadcrumbs>
            <v-row justify="center">
                <v-col class="viewSpaces" cols="12">

                    <div class="principal-layout margin-bot" v-if="studentData">
                        <div class="layout-grid d-flex flex-wrap">
                            <div class="layout-grid__column--left pr-0 pr-sm-3">
                                <div class="welcome-banner d-flex align-center justify-center mb-5">
                                    <!--Welcome banner component-->
                                    <PrincipalBanner :classStarted="isClassStart" :onboardingStatus="onboardingStatus" v-if="onboardingStatus.showBanners != null"></PrincipalBanner>
                                </div>
                                <div class="subjects-tabs d-flex align-center justify-center mb-5">
                                    <!--Subjects tabs component-->
                                    <SubjectsTab></SubjectsTab>
                                </div>
                                <div class="calendar-container d-flex align-center justify-center mb-5">
                                    <!--Calendar component-->
                                    <Calendar></Calendar>
                                </div>
                            </div>
                            
                        </div>
                        <v-dialog
                            persistent
                            no-click-animation
                            attach=".principal-layout"
                            content-class="first-login-video"
                            v-model="firstLoginVideoDialog"
                        >
                            <iframe
                                v-if="firstLoginVideoDialog"
                                type="text/html" width="640" height="360"
                                iv_load_policy="3" modestbranding="1" showinfo="0"
                                :src="`${firstLoginVideoSrc}?rel=0`"
                                frameborder="0"
                                allowfullscreen
                            ></iframe>
                            <v-btn icon dark class="close-dialog" @click="firstLoginVideoDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                        </v-dialog>
                    </div>

                </v-col>
            </v-row>
        </v-container>
        <ReferFriendModal  :open="showModalReferFriend" @close="showModalReferFriend = false" />
        <FirmNewPP v-if="$isTeclab" :open="!!$route.query.pp || showModalFirmNewPP" @close="showModalFirmNewPP = false" />
    </v-container>
</template>

<script>
    import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
    import PrincipalBanner from '../Components/Banners/PrincipalBanner';
    import SubjectsTab from '../Components/SubjectsTab';
    import Calendar from '../Components/Calendar';
    import ReferFriendModal from '../Components/ReferFriendModal.vue'
    import FirmNewPP from '../Components/FirmNewPP.vue'
    import AuthService from '@/plugins/auth.service';
    import ListStudents from '@/constants/listStudents';

    import Configuration from '../../../../core/constants/configuration';

    import { $studentAccount, $hubspot, $banners } from '../Services';
    import moment from 'moment';
    import { mapGetters } from 'vuex';

    export default {
        name: 'DashboardStudent',
        components: {
            Breadcrumbs,
            PrincipalBanner,
            SubjectsTab,
            Calendar,
            ReferFriendModal,
            FirmNewPP,
        },
        data() {
            return {
                showModalReferFriend: false,
                showModalFirmNewPP: false,
                firstLoginVideoDialog: false,
                firstLoginVideoSrc: 'https://www.youtube.com/embed/z8a-_e9R4zI',
                onboardingStatus: {
                    classStart: null,
                    aproboTest: false,
                    test: false,
                    schedule: false,
                    onbordingDate: null,
                    horario: null,
                    onbording: false,
                    habilidades: false,
                    showBanners: null
                },
                smallBanners: [
                ],
            }
        },
        created() {
            this.getOnboardingStatus()
            if (this.$isIPP) {
              this.getReEnrollmentStatus()
            }
        },
        mounted() {
            this.firstLoginVideoDialog = this.showFirstLoginVideo
            this.fetchBanners()
            const alumnoSeleccionado = JSON.parse(localStorage.getItem('alumnoSeleccionado'));
            const dniAlumnoBloqueado = Configuration.value('app') == 'portalalumno' && AuthService.isStudent() && alumnoSeleccionado ? ListStudents.find(
                dni => dni == alumnoSeleccionado.userData.username
            ) : null;

            this.showModalFirmNewPP = !!dniAlumnoBloqueado;
        },
        methods: {
            async getReEnrollmentStatus() {
              try {
                const reEnrollmentOptions = await $studentAccount.find(`reEnrollmentStatus/${this.studentRegister}`)
                if (reEnrollmentOptions.data.reEnrollment) {
                  const reenrollmentBanner = this.smallBanners.find(banner => banner.id == 'rematricula')
                  if (reenrollmentBanner) reenrollmentBanner.visible = true
                }
              } catch (err) {
                const reenrollmentBanner = this.smallBanners.find(banner => banner.id == 'rematricula')
                if (reenrollmentBanner) reenrollmentBanner.visible = false
                throw err
              }
            },
            async getOnboardingStatus() {
                try {
                    const {data} = await $hubspot.find('contact/onbording-status', null, { params: {studentId: this.studentId} })
                    this.onboardingStatus = data
                    this.onboardingStatus.onbordingDate = data.onbordingDate ? data.onbordingDate.slice(0,10) : null
                } catch (err) {
                    this.onboardingStatus = {
                        classStart: null,
                        aproboTest: false,
                        test: false,
                        schedule: false,
                        onbordingDate: null,
                        horario: null,
                        onbording: false,
                        habilidades: false,
                        showBanners: false
                    }
                    throw err
                } finally {
                    if (this.onboardingStatus.showBanners && this.isClassStart) {
                       this.setOnboardingSideBanners()
                    }
                }
            },
            async fetchBanners() {
                try {
                    const banners = await $banners.find('details');
                    this.smallBanners = banners.data.map(banner => {
                        const image = banner.images.find(image => !image.background)
                        const bgImg = banner.images.find(image => image.background)?.fileUrl 
                        return {
                            type: banner.type,
                            color: banner.color,
                            bgImg: bgImg ? this.bannerBaseURL+bgImg : null,
                            code: banner.code,
                            image: {
                                src: this.bannerBaseURL+image.fileUrl,
                                position: image.position,
                                corner: image.corner,
                            },
                            text: [ banner.title, banner.comment ],
                            buttons: banner.buttons
                        }
                    });

                    
                    this.smallBanners.unshift({
                        type: {
                            meaning: '',
                            type: null,
                            value: 272,
                        },
                        color: '#106ca7',
                        bgImg: '',
                        image: {
                            src: require(`@/assets/theme/${this.$theme}/bannerReferido.gif`),
                            position: 0,
                            corner: false
                        },
                        text: ['', ''],
                        buttons: [{
                            id: 7,
                            link: 'action-referFriend',
                            text: 'Referir amigo'
                        }]
                    });

                } catch (err) {
                    this.smallBanners = []
                    throw err
                }
            },
        },
        computed: {
            ...mapGetters({
                studentRegister: 'commons/getStudentActualRegister',
                studentId: 'commons/getStudentId',
                studentData: 'commons/getStudentData',
                bannerBaseURL: 'commons/getAssetsURL'
            }),
            activeBanners() {
                return this.smallBanners.filter(banner => banner.visible == true)
            },
            isClassStart() {
                return this.onboardingStatus.classStart ? moment(this.onboardingStatus.classStart).isBefore(new Date()) : false
            },
            getOnboardingDate() {
                const horario = this.onboardingStatus.horario ? this.onboardingStatus.horario.substr(0, 5) : ''
                if (this.onboardingStatus.onbordingDate) return moment(`${this.onboardingStatus.onbordingDate.substr(0, 10)} ${horario}`).locale('es').format('D [de] MMMM [a las] H[hs]')
                else return moment().locale('es').format('D [de] MMMM [a las] H[hs]')
            },
            showFirstLoginVideo() {
                return !this.$isGestor && this.studentData.firstLogin
            },
            onboardingCharlaBienvenidaUrl() {
              switch(this.$country) {
                case 'chile':
                  if(this.this.onboardingStatus?.aproboTest) {
                    return 'https://instituto.ipp.cl/onboarding-2';
                  }
                  return 'https://instituto.ipp.cl/onboarding-1'
                case 'global':
                  return 'https://onboarding.teclab.edu.ar/charla-de-bienvenida'
                case 'peru':
                  return 'https://onboarding.teclab.edu.pe/charla-de-bienvenida'
                case 'mexico':
                  return 'https://onboarding.onmex.mx/es-mx/charla-de-bienvenida'
                default:
                  return 'https://onboarding.teclab.edu.ar/charla-de-bienvenida'
              }
            },
            onboardingHabilidadesUrl() {
              switch(this.$country) {
                case 'chile':
                  return 'https://instituto.ipp.cl/test-de-habilidades-final';
                case 'global':
                  return 'https://onboarding.teclab.edu.ar/habilidades-teclab'
                case 'peru':
                  return 'https://onboarding.teclab.edu.pe/habilidades-teclab'
                case 'mexico':
                  return 'https://onboarding.onmex.mx/es-mx/habilidades-onmex'
                default:
                  return 'https://onboarding.teclab.edu.ar/habilidades-teclab'
              }
            },
        },
    }
</script>

<style lang="sass" scoped>

    .layout-grid
        &__column--left
            width: 65%
            div
                width: 100%
        &__column--right
            width: 35%
            div
                width: 100%

    .welcome-banner
        min-height: 200px

    .subjects-tabs
        min-height: 254px

    .calendar-container
        min-height: 290px

    .secondary-banner--others
        min-height: 130px

    .close-dialog
        position: absolute
        top: 10px
        right: 10px

    @media only screen and (max-width: 600px)
        .layout-grid
            div
                width: 100%

</style>

<style lang="sass">
    .principal-layout
        > .v-dialog__content
            > .first-login-video
                position: relative
                width: 640px
                height: 360px
                max-height: 100% !important
                line-height: 0 !important
</style>
